import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography, Svg, Button, useThemeValue } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useDialog } from '@/_shared/hooks';

export const DialogConfirmExitFromSurvey: FC = () => {
  const t = useTranslations(
    'configuration.learning.employeeCompleteSurvey.confirmExitFromSurveyDialog',
  );
  const navigate = useNavigate();
  const { closeDialog, Dialog, isOpen } = useDialog('confirmExitFromSurveyDialog');
  const gapL = convertSizeToNumber(`${useThemeValue('sizes', 'l')}`);

  const onExitConfirm = useCallback(() => {
    closeDialog();
    navigate(Routes.Homepage);
  }, [closeDialog, navigate]);

  return (
    <Dialog maxWidth='700px' open={isOpen} title={undefined} onClose={closeDialog} closeButton>
      <Box display='flex' mb='m' flexDirection='column' px='s'>
        <Svg name='info' size='xxl' />
      </Box>
      <Box display='flex' mx='l' flexDirection='column' px='s'>
        <Typography variant='h3' color='primary/text' textAlign='center'>
          {t('title')}
        </Typography>
      </Box>
      <Box display='flex' mt='s' flexDirection='column' px='s'>
        <Typography variant='p2/light' color='primary/text' textAlign='center'>
          {t('description')}
        </Typography>
      </Box>

      <Box
        display='flex'
        mx='l'
        flexDirection='row'
        px='s'
        style={{ gap: gapL }}
        justifyContent='center'
      >
        <Button
          variant='link/primary'
          onClick={closeDialog}
          mt='l'
          style={{ textDecoration: 'none' }}
        >
          <Svg name='close' fill='primary/text' size='s' mr='xs' />
          {t('cancel')}
        </Button>

        <Button variant='primary' onClick={onExitConfirm} mt='l'>
          {t('confirm')}
        </Button>
      </Box>
    </Dialog>
  );
};
